import { useContext } from 'react';
import { AnalyticsContext } from 'components/Analytics';

export default () => {
  return useContext(AnalyticsContext) || {};
};
